import React from 'react'
import Home from './Home';
import Cuisine from './Cuisine';
import Searched from './Searched';
import Recipe from './Recipe';
import AddRecipe from './AddRecipe';
import UserGuide from './UserGuide';
import { Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import AddIngredients from './AddIngredients';

function Pages() {
  const location = useLocation();
  return (
    <AnimatePresence mode='wait'>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/cuisine/:type" element={<Cuisine />} />
        <Route path="/searched/:search" element={<Searched />} />
        <Route path="/recipe/:name" element={<Recipe />} />
        <Route path="/add-recipe" element={<AddRecipe />} />
        <Route path="/user-guide" element={<UserGuide />} />
        <Route path="/manage-ingredients" element={<AddIngredients />} />
      </Routes>
    </AnimatePresence>
  )
}

export default Pages